/** 订单标签（系统保留） */
export enum PreservedOrderTag {
    /** 奇门仓储 */
    QI_MEN_WAREHOUSE = '奇门仓储',
    /** 云仓 */
    CLOUD_WAREHOUSE = '云仓',
    /** 开放平台 */
    OPEN_PLATFORM = '开放平台',
    /** 补发更新线上 */
    REPLENISHMENT_UPDATE_ONLINE = '补发更新线上',
    /** 线上下载 */
    ONLINE_DOWNLOAD = '线上下载',
    /** 可合并 */
    MERGE_ABLE = '可合并',
    /** 特殊退款单 */
    SPECIAL_REFUND_ORDER = '特殊退款单',
    /** 价保单 */
    PRICE_PROTECTION_ORDER = '价保单',
    /** 异常冲抵 */
    ABNORMAL_OFFSET = '异常冲抵',
    /** 换货单 */
    EXCHANGE_ORDER = '换货单',
    /** 红色标 */
    RED_TAG = '红色标',
    /** 黄色标 */
    YELLOW_TAG = '黄色标',
    /** 绿色标 */
    GREEN_TAG = '绿色标',
    /** 蓝色标 */
    BLUE_TAG = '蓝色标',
    /** 紫色标 */
    PURPLE_TAG = '紫色标',
    /** 黑名单 */
    BLACKLIST = '黑名单',
    /** 预发货 */
    PRE_SHIPMENT = '预发货',
    /** 无信息件绑定 */
    NO_INFO_BIND = '无信息件绑定',
    /** 京东换货 */
    JD_EXCHANGE = '京东换货',
    /** 修改退 */
    MODIFY_RETURN = '修改退',
    /** 换改退 */
    CHANGE_RETURN = '换改退',
    /** 自动退款成功 */
    AUTO_REFUND_SUCCESS = '自动退款成功',
    /** 自动退款失败 */
    AUTO_REFUND_FAIL = '自动退款失败',
    /** 自动同意退货成功 */
    AUTO_AGREE_RETURN_SUCCESS = '自动同意退货成功',
    /** 自动同意退货失败 */
    AUTO_AGREE_RETURN_FAIL = '自动同意退货失败',
    /** 自动推送供应商成功 */
    AUTO_PUSH_SUPPLIER_SUCCESS = '自动推送供应商成功',
    /** 自动推送供应商失败 */
    AUTO_PUSH_SUPPLIER_FAIL = '自动推送供应商失败',
    /** 自动退货退款成功 */
    AUTO_RETURN_REFUND_SUCCESS = '自动退货退款成功',
    /** 自动退货退款失败 */
    AUTO_RETURN_REFUND_FAIL = '自动退货退款失败',
    /** 周期购订单 */
    PERIOD_ORDER = '周期购订单',
    /** 平台极速退款 */
    PLATFORM_FAST_REFUND = '平台极速退款',
    /** 天猫新版换货 */
    TMALL_NEW_EXCHANGE = '天猫新版换货',
    /** 货主自主收货 */
    OWNER_RECEIVE = '货主自主收货',
    /** 订单交易完成 */
    ORDER_TRADE_COMPLETE = '订单交易完成',
    /** 工单 */
    WORK_ORDER = '工单',
    /** 物流拦截已登记 */
    LOGISTICS_INTERCEPT_REGISTERED = '物流拦截已登记',
    /** 物流拦截成功 */
    LOGISTICS_INTERCEPT_SUCCESS = '物流拦截成功',
    /** 物流拦截失败 */
    LOGISTICS_INTERCEPT_FAIL = '物流拦截失败',
    /** 取消拦截 */
    CANCEL_INTERCEPT = '取消拦截',
    /** 物流退改中 */
    LOGISTICS_RETURN_CHANGE = '物流退改中',
    /** 物流拦截完结 */
    LOGISTICS_INTERCEPT_FINISH = '物流拦截完结',
    /** 标记申请拦截 */
    MARK_APPLY_INTERCEPT = '标记申请拦截',
    /** 标记拦截成功 */
    MARK_INTERCEPT_SUCCESS = '标记拦截成功'
}
